import { coachFetch } from "apps/user/learner/api/coach";
import {
  FeedbackState,
  OriEmbeddedUi,
} from "apps/user/learner/pages/chat/types";

export type ConversationStatus = "active" | "completed" | "archived";

export type ThreadLifecycle = "continuous" | "bounded";

// Additive thread identity carried on each history entry (see coach
// views_history). Null only for legacy rows created before Threads existed.
export interface ConversationThreadRef {
  id: string;
  lifecycle: ThreadLifecycle;
  configuration_id: string | null;
}

export interface ConversationSummary {
  id: string;
  conversation_type: string;
  status: ConversationStatus;
  thread: ConversationThreadRef | null;
  title: string | null;
  summary: string | null;
  last_ori_message: string | null;
  last_message_content: string | null;
  started_at: string;
  last_active_at: string;
  completed_at: string | null;
  archived_at: string | null;
  turn_count: number;
  message_count: number;
}

export interface ConversationsResponse {
  conversations: ConversationSummary[];
  pagination: {
    has_more: boolean;
    next_cursor: string | null;
  };
}

export interface ConversationDetailMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  created_at: string;
  options: unknown;
  options_source?: unknown;
  reaction: string | null;
  embedded_ui: OriEmbeddedUi | null;
  user_feedback: FeedbackState | null;
}

export interface ConversationDetailResponse {
  id: string;
  conversation_type: string;
  status: string;
  title: string | null;
  summary: string | null;
  started_at: string;
  last_active_at: string;
  completed_at: string | null;
  archived_at: string | null;
  messages: ConversationDetailMessage[];
  facts_learned: unknown[];
}

export function fetchConversations(params?: {
  lifecycle?: ThreadLifecycle;
}): Promise<ConversationsResponse> {
  const query = params?.lifecycle ? `?lifecycle=${params.lifecycle}` : "";
  return coachFetch<ConversationsResponse>(`/api/conversations/${query}`);
}

export function fetchConversation(
  id: string
): Promise<ConversationDetailResponse> {
  return coachFetch<ConversationDetailResponse>(`/api/conversations/${id}/`);
}
